import React from 'react';
import { bool, func, string, object } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { propTypes } from '../../util/types';
import { maxLength, required, composeValidators } from '../../util/validators';
import { Form, FieldTextInput, PrimaryButton } from '../../components';

import css from './EditListingDescriptionForm.css';

const TITLE_MAX_LENGTH = 250;
const DESCRIPTION_MAX_LENGTH = 5000;

const EditListingDescriptionFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
      } = fieldRenderProps;
      const titleLabel = intl.formatMessage({ id: 'EditListingDescriptionForm.title.label' });
      const titlePlaceholderMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.title.placeholder' });
      const titleRequiredMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.title.required' });
      const titleMaxLengthMessage = intl.formatMessage(
        { id: 'EditListingDescriptionForm.title.maxLength' },
        {
          maxLength: TITLE_MAX_LENGTH,
        }
      );
      const descriptionMaxLengthMessage = intl.formatMessage(
        { id: 'EditListingDescriptionForm.description.maxLength' },
        {
          maxLength: DESCRIPTION_MAX_LENGTH,
        }
      );

      const descriptionLabel = intl.formatMessage({ id: 'EditListingDescriptionForm.description.label' });
      const descriptionPlaceholderMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.description.placeholder' });
      const maxLengthTitle = maxLength(titleMaxLengthMessage, TITLE_MAX_LENGTH);
      const maxLengthDescription = maxLength(descriptionMaxLengthMessage, DESCRIPTION_MAX_LENGTH);
      const descriptionRequiredMessage = intl.formatMessage({ id: 'EditListingDescriptionForm.description.required' });

      const errorMessage = updateError ? (
        <p className={css.error}>
          <FormattedMessage id='EditListingDescriptionForm.updateFailed' />
        </p>
      ) : null;
      const classes = classNames(css.root, className);
      const submitReady = updated && pristine;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          <FieldTextInput
            id='title'
            name='title'
            className={css.title}
            type='text'
            label={titleLabel}
            placeholder={titlePlaceholderMessage}
            maxLength={TITLE_MAX_LENGTH}
            validate={composeValidators(required(titleRequiredMessage), maxLengthTitle)}
          />
          <FieldTextInput
            id='description'
            name='description'
            className={css.description}
            type='textarea'
            label={descriptionLabel}
            placeholder={descriptionPlaceholderMessage}
            validate={composeValidators(required(descriptionRequiredMessage), maxLengthDescription)}
          />
          <div className={css.buttonContainer}>
            <PrimaryButton
              className={css.submitButton}
              type='submit'
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingDescriptionFormComponent.defaultProps = {
  className: null,
  updateError: null,
  initialValues: {},
};

EditListingDescriptionFormComponent.propTypes = {
  className: string,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
  initialValues: object,

  // from injectIntl
  intl: intlShape.isRequired,
};

const EditListingDescriptionForm = compose(injectIntl)(EditListingDescriptionFormComponent);
EditListingDescriptionForm.displayName = 'EditListingDescriptionForm';

export default EditListingDescriptionForm;



// WEBPACK FOOTER //
// ./src/forms/EditListingDescriptionForm/EditListingDescriptionForm.js